import { Navigate } from "react-router-dom";
import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { useAuth } from "../contexts/AuthContext";

const ROLE_PORTAL = {
  driver:     { path: "/sawakeen-jumlaty", label: "السائق" },
  mujahez:    { path: "/mujahez-jumlaty",  label: "المجهّز" },
  supervisor: { path: "/mushrif-jumlaty",  label: "المشرف" },
  mandoob:    { path: "/mandoob",          label: "المندوب" },
  rep:        { path: "/mushrif-jumlaty",  label: "المشرف" },
};

/**
 * Wraps customer-facing pages (Home, Cart, Orders, Rewards…) so that
 * drivers, mujahezeen and supervisors who navigate (or are redirected) to
 * them by mistake are sent back to their own work portal instead of seeing
 * the storefront. Shows a friendly one-time welcome toast on redirect.
 * Admins keep peek access — useful for QA. Unauthenticated visitors keep
 * their browsing rights (catalog is public).
 */
const CustomerRoute = ({ children }) => {
  const { user, loading } = useAuth();
  // Track which user we've already greeted in this session to avoid spamming
  // the toast on every re-render or refresh.
  const greetedRef = useRef(new Set());

  useEffect(() => {
    if (!user) return;
    const meta = ROLE_PORTAL[user.role];
    if (!meta) return;
    const key = `${user.id}:${user.role}`;
    if (greetedRef.current.has(key)) return;
    greetedRef.current.add(key);
    const name = user.full_name || user.phone || "";
    toast.success(`أهلاً ${name} — تم تحويلك تلقائياً لبوابة ${meta.label}`, {
      duration: 4000,
      id: `role-redirect-${key}`,
    });
  }, [user]);

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-[#5C6E64]">جاري التحميل...</div>
      </div>
    );
  }

  if (user) {
    const meta = ROLE_PORTAL[user.role];
    if (meta) return <Navigate to={meta.path} replace />;
  }

  return children;
};

export default CustomerRoute;
